import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get, del } from "../../lib/request"

const normalizeSessionList = (res) => {
  if (Array.isArray(res?.data)) return res.data
  if (Array.isArray(res)) return res
  return []
}

export const fetchUserSessions = createAsyncThunk(
  "userSessions/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await get("users/sessions")
      return normalizeSessionList(res)
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to load sessions")
    }
  },
)

export const revokeOtherUserSessions = createAsyncThunk(
  "userSessions/revokeOthers",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      await del("users/sessions")
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to sign out other devices")
    }
    try {
      await dispatch(fetchUserSessions()).unwrap()
    } catch {
      /* revoke succeeded; refresh list is best-effort */
    }
    return true
  },
)

const initialState = {
  sessions: [],
  status: "idle",
  error: null,
  revokeStatus: "idle",
  revokeError: null,
}

const userSessionsSlice = createSlice({
  name: "userSessions",
  initialState,
  reducers: {
    clearUserSessions: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserSessions.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchUserSessions.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.sessions = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(fetchUserSessions.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
      .addCase(revokeOtherUserSessions.pending, (state) => {
        state.revokeStatus = "loading"
        state.revokeError = null
      })
      .addCase(revokeOtherUserSessions.fulfilled, (state) => {
        state.revokeStatus = "succeeded"
      })
      .addCase(revokeOtherUserSessions.rejected, (state, action) => {
        state.revokeStatus = "failed"
        state.revokeError = action.payload
      })
  },
})

export const { clearUserSessions } = userSessionsSlice.actions
export default userSessionsSlice.reducer
